var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowIFrame),expression:"isShowIFrame"}]},[_c('div',{ref:"pin"}),_c('div',{ref:"ifm",staticClass:"iframe-wrapper",class:_vm.$root.siteRenderer},_vm._l((_vm.allIFrames),function(url){return _c('iframe',{class:{visible: url === _vm.currentIFrame},attrs:{"src":url}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }